import React, { ReactElement } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, notification } from 'antd';
import { isEmpty } from 'lodash';

import { useContractState } from 'pricing/components/contract/useContractState/useContractState';
import { putContractStatusActive } from 'pricing/utilities/contract/putContractStatus/putContractStatus';
import { PricingRoutes } from 'pricing/types';

function StartContract(): ReactElement {
  const { state } = useContractState();
  const { contract } = state;
  const contractTerms = contract?.breederContractTerms;
  const history = useHistory();

  const handleStartContract = async () => {
    try {
      await putContractStatusActive(contract?.id);
      history.push(PricingRoutes.ContractList);
      notification.success({
        message: 'Contract added',
        description: `The Contract ID ${contract?.id} has been added.`,
      });
    } catch (e) {
      notification.error({
        message: `Couldn't start contract`,
      });
    }
  };

  return (
    <Button
      data-testid="start-contract"
      type="primary"
      onClick={handleStartContract}
      disabled={isEmpty(contractTerms)}
    >
      Start Contract
    </Button>
  );
}

export default StartContract;
